import React from "react";
import GlobalContextProvider from "./src/context/global-context-provider";
import { BookingModalProvider } from "./src/context/booking-modal-context.js";
import "./src/style/global.css";

export const wrapRootElement = ({ element }) => {
  return (
    <GlobalContextProvider>
      <BookingModalProvider>{element}</BookingModalProvider>
    </GlobalContextProvider>
  );
};
